import React from 'react';
import BaseScadaNode from './BaseScadaNode';

export function BoxSealerSVG({ config = {}, width = 90, height = 70, liveValues = {} }) {
    const running = parseFloat(liveValues.state ?? 0) >= parseFloat(config.threshold ?? 0.5);
    const hasError = liveValues.error === 1 || liveValues.error === true ||
        liveValues.error === '1' || liveValues.error === 'true';
    const statusColor = hasError ? '#EF4444' : running ? '#22C55E' : '#64748B';

    const cy = height / 2;
    const count = parseInt(liveValues.count ?? 0);
    const bodyX = 4;
    const bodyW = width - 8;
    const bodyY = 4;
    const bodyH = height - 8;

    return (
        <svg width={width} height={height} viewBox={`0 0 ${width} ${height}`} style={{ display: 'block' }}>
            {/* Machine body */}
            <rect x={bodyX} y={bodyY} width={bodyW} height={bodyH} rx={4}
                fill="#1E293B" stroke={statusColor} strokeWidth={2} />

            {/* Open box entering (left) */}
            <g transform={`translate(10, ${cy - 12})`}>
                {/* Box body */}
                <rect x={0} y={6} width={16} height={14} fill="#334155" stroke="#94A3B8" strokeWidth={1.2} />
                {/* Open flaps */}
                <line x1={0} y1={6} x2={-3} y2={1} stroke="#94A3B8" strokeWidth={1.2} />
                <line x1={16} y1={6} x2={19} y2={1} stroke="#94A3B8" strokeWidth={1.2} />
            </g>

            {/* Sealing mechanism (center) */}
            <g opacity={running ? 1 : 0.5}>
                {/* Top sealing bar */}
                <rect x={width / 2 - 10} y={cy - 14} width={20} height={5} rx={2}
                    fill={statusColor} opacity={0.8} />
                {/* Bottom sealing bar */}
                <rect x={width / 2 - 10} y={cy + 9} width={20} height={5} rx={2}
                    fill={statusColor} opacity={0.8} />
                {/* Roller */}
                <circle cx={width / 2} cy={cy - 2} r={5} fill="#0F172A" stroke={statusColor} strokeWidth={1.5} />
                <circle cx={width / 2} cy={cy - 2} r={2} fill={statusColor} opacity={0.4} />
                {/* Tape line */}
                {running && (
                    <line x1={width / 2 - 12} y1={cy - 2} x2={width / 2 + 12} y2={cy - 2}
                        stroke={statusColor} strokeWidth={1.5} strokeDasharray="4 3">
                        <animate attributeName="stroke-dashoffset" from="0" to="-7" dur="0.5s" repeatCount="indefinite" />
                    </line>
                )}
            </g>

            {/* Sealed box exiting (right) */}
            <g transform={`translate(${width - 30}, ${cy - 12})`}>
                {/* Front face */}
                <rect x={0} y={4} width={16} height={16} fill="#334155" stroke={statusColor} strokeWidth={1.2} />
                {/* Top face (closed) */}
                <rect x={0} y={0} width={16} height={4} fill="#475569" stroke={statusColor} strokeWidth={1} />
                {/* Tape line across top */}
                <line x1={8} y1={0} x2={8} y2={20} stroke={statusColor} strokeWidth={1.5} opacity={0.7} />
            </g>

            {/* Count display */}
            {count > 0 && (
                <text x={width / 2} y={height - 8} textAnchor="middle"
                    fill="#94A3B8" fontSize={9} fontFamily="monospace">
                    {count}
                </text>
            )}

            {/* Error flash */}
            {hasError && (
                <rect x={2} y={2} width={width - 4} height={height - 4} rx={4}
                    fill="none" stroke="#EF4444" strokeWidth={2}>
                    <animate attributeName="stroke-opacity" values="1;0;1" dur="0.6s" repeatCount="indefinite" />
                </rect>
            )}
        </svg>
    );
}

export default function BoxSealerNode(props) {
    const { data } = props;
    const w = data?.width || 90;
    const h = data?.height || 70;
    return (
        <BaseScadaNode {...props}>
            <BoxSealerSVG config={data?.config} width={w} height={h} liveValues={data?.liveValues || {}} />
            {data?.label && (
                <div style={{ textAlign: 'center', fontSize: 10, color: '#94A3B8', marginTop: 2,
                    overflow: 'hidden', whiteSpace: 'nowrap', textOverflow: 'ellipsis' }}>
                    {data.label}
                </div>
            )}
        </BaseScadaNode>
    );
}
